import React from 'react';
import Button from '../../../components/Button';
import ProjectItem from './ProjectItem';
import EmptyProjectsView from './EmptyProjectsView';
import { Project } from '../hooks/useProjects';

interface ProjectsListProps {
  projects: Project[];
  isLoading: boolean;
  error: string | null;
  onAddProject: () => void;
  onFindLocation: () => void;
  onViewAnalysis: (projectId: string) => void;
  onRunAgain: (projectId: string) => void;
  onDelete: (projectId: string) => void;
}

const ProjectsList: React.FC<ProjectsListProps> = ({
  projects,
  isLoading,
  error,
  onAddProject,
  onFindLocation,
  onViewAnalysis,
  onRunAgain,
  onDelete
}) => {
  return (
    <div>
      {/* Header with Title and Add Button */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '1.5rem',
        flexWrap: 'wrap',
        gap: '1rem'
      }}>
        <div>
          <h3 style={{ 
            fontSize: '1.4rem', 
            color: '#1e1e1e',
            margin: 0
          }}>
            Your Projects
          </h3>
          {!isLoading && projects.length > 0 && (
            <p style={{ 
              color: '#666', 
              margin: '0.25rem 0 0 0',
              fontSize: '0.9rem'
            }}>
              {projects.length} project{projects.length !== 1 ? 's' : ''}
            </p>
          )}
        </div>
        
        <Button 
          onClick={onAddProject} 
          style={{ 
            backgroundColor: '#7FE7D9', 
            color: '#1e1e1e',
            padding: '0.75rem 1.25rem',
            fontSize: '1rem'
          }}
        >
          Add New Project
        </Button>
      </div>

      {/* Loading, Error, or Empty States */}
      {isLoading ? (
        <div style={{ 
          textAlign: 'center', 
          padding: '2rem',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
        }}>
          <p>Loading your projects...</p>
        </div>
      ) : error ? (
        <div style={{ 
          color: 'red', 
          padding: '1.5rem', 
          backgroundColor: '#fff', 
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
        }}>
          {error}
        </div>
      ) : projects.length === 0 ? (
        <EmptyProjectsView onFindLocation={onFindLocation} />
      ) : (
        // Project Cards Grid
        <div style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: '1rem'
        }}>
          {projects.map((project) => (
            <ProjectItem
              key={project.id}
              project={project}
              onViewAnalysis={onViewAnalysis}
              onRunAgain={onRunAgain}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectsList;
